export default __webpack_public_path__ + "static/gotham-medium-16c7cb8c6d8f8d91f72c05ed107fd8f4.woff2";